/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react';

const API_URL = import.meta.env.VITE_API_URL;

function AllEvaluationMappings() {
  const { data, setData } = useDataContext();
  const hasFetched = useRef(false);

  useEffect(() => {
    // 1. เช็คว่ามีข้อมูลหรือยัง
    if (data.evaluationMappings && data.evaluationMappings.length > 0) return;
    
    // 2. กันยิงซ้ำ
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const currentYear = new Date().getFullYear();
        const response = await fetch(`${API_URL}/evaluation-mapping/${currentYear}`);
        const result = await response.json();
        
        setData(prev => ({ ...prev, evaluationMappings: result.data || [] }));
      } catch (error) {
        console.error("Error fetching evaluation mappings:", error);
        hasFetched.current = false;
      }
    };

    fetchData();
  }, []);

  return null;
}

export default AllEvaluationMappings;